(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2071],{

/***/ 33175:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design",
      function () {
        return __webpack_require__(83280);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34937);

/* harmony default export */ __webpack_exports__["default"] = (ui__WEBPACK_IMPORTED_MODULE_0__/* .StyleguideModule */ .qL);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(33175); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);